import { IconCalendarTime } from '@tabler/icons-react';

import { Box, Typography } from '@mui/material';

import { formatDateTimeBR } from '@octopus/formatters';
import { payslipStatuses } from '@octopus/payroll-types';

import { usePopover } from '../../../modules/hooks/usePopover';
import { TypedPeriodSummary } from '../types';

export const SendPayslip = ({ row }: { row: TypedPeriodSummary }) => {
  const [Popover, handlePopoverOpen, handlePopoverClose] = usePopover();
  const hasAlreadySentAll =
    row.totalizers?.counts?.payslips?.byStatus?.[payslipStatuses.sent] > 0;

  if (hasAlreadySentAll) {
    return '';
  }

  if (row.payslipScheduledSendAt) {
    return (
      <Box
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        display="flex"
        alignItems="center"
        gap={1}
      >
        <Typography variant="body2" color="text.placeholder">
          {formatDateTimeBR(row.payslipScheduledSendAt)}
        </Typography>
        <IconCalendarTime size={16} className="disabled" />
        <Popover>{'Programado para esta data'}</Popover>
      </Box>
    );
  }

  return formatDateTimeBR(row.paymentDate);
};
